import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import block from 'bem-cn';
import SVGInline from 'react-svg-inline';

import ArrowSVG from './img/arrow.svg';
import './Select.scss';

const b = block('select-mobile-2');

const Select = ({ items, onChange, placeholder = '', color = '', paginator, locale }) => {
  const [isOpen, changeOpen] = useState(false);

  const itemsList = useMemo(
    () =>
      items.map(item => {
        const onItemChange = () => {
          const changedList = items.map(item2 => ({
            ...item2,
            active: item2.key === item.key,
          }));

          const checkHasActive = changedList.filter(item2 => item2.active);
          if (checkHasActive.length === 0) changedList[0].active = true;
          onChange(changedList);
          changeOpen(false);
        };

        return (
          <li key={item.value} className={b('item', { color })} onClick={onItemChange}>
            <div className={b('item-main')}>
              <span className={b('item-text')}>
                {locale ? (locale[item.renderElement] ?? item.renderElement) : item.renderElement}
              </span>
              {item.svg && <SVGInline className={b('item-icon').toString()} svg={item.svg} />}
            </div>
          </li>
        );
      }),
    [items, onChange, changeOpen, paginator, color],
  );

  const activeItem = useMemo(() => items.find(item => item.active) || items[0], [items]);

  return (
    <div
      className={b({ open: isOpen, color, paginator })}
      onClick={() => changeOpen(!isOpen)}
      onMouseLeave={() => changeOpen(false)}>
      <div className={b('item', { current: true, color })}>
        <span className={b('item-text')}>
          {locale ? (locale[activeItem.selectedRenderElement] ?? activeItem.selectedRenderElement) : activeItem.selectedRenderElement}
        </span>
        <SVGInline className={b('arrow').toString()} svg={ArrowSVG} />
      </div>
      {isOpen &&
        <>
          {color === 'bonus' && <div className={b('gap')} />}
          <ul className={b('items-list', { color })}>
            {itemsList}
          </ul>
        </>}
    </div>
  );
};

Select.propTypes = {
  items: PropTypes.array.isRequired,
  placeholder: PropTypes.string,
  color: PropTypes.string,

  onChange: PropTypes.func.isRequired,
};

export default Select;
